module.exports = __webpack_public_path__ + "r-v3/img/ico_study_setting_white.c743dfdc.svg";